import { Controller } from 'stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
static targets = ["saveListBtn"]



	connect () {

		console.log("sortable")

		this.sortable = Sortable.create(this.element, {
	
			group: "bullet-points",
  
			draggable: ".bullet-point",
			handle: ".bullet-point-handle",
			delay: 0,
			swapThreshold: 1,
			onMove: function(evt) {

			},
			onEnd: function(evt) {
	
				console.log("onEnd triggered")

				// send event: save bullet list

				/* var newSortedEvent = new CustomEvent("sorted-bullet-list")
				window.dispatchEvent(newSortedEvent) */
				document.getElementById("saveBulletListBtn").click()

			}
		})
	}


	disconnect () {
		/* this.sortable.destroy()
		this.sortable = undefined */
	}

}